import type { ComponentType } from 'react'
import type { FamilyEditorSidebarContentProps } from './FamilyEditorSidebarContentFallback'
import { FamilyEditorSidebarContentFurniture } from './FamilyEditorSidebarContentFurniture'

// TODO(catalog-multilang Phase 4 / SOLY-CATALOG-001):
// Replace this hard-coded registry with a lookup on CatalogProduct.familyGroup. Phase 3l
// split base_unit / wall_unit / tall_unit on the legacy `furniture` enum into multiple
// per-furniture-type products (base_unit_standard, base_unit_sink, wall_unit_hood,
// tall_unit_oven, etc.). The line model only carries `familyKey` (the per-product code),
// so we have to enumerate every split key below — easy to miss when a new variant ships.
// Plan (BE side): denormalize `familyGroup` on ConfigurableItem (V075 + backfill) and
// expose it via the line DTO. Then this registry keys on familyGroup ("base_unit",
// "wall_unit", "tall_unit", "storage_unit") and stays stable across future splits.

export function getFamilyEditorSidebarContentByFamilyKey(
  familyKey: string | null | undefined
): ComponentType<FamilyEditorSidebarContentProps> | null {
  if (!familyKey) return null
  const registry: Record<string, ComponentType<FamilyEditorSidebarContentProps>> = {
    // Legacy keys — kept for any line not yet migrated by /admin/catalog/migration.
    base_unit: FamilyEditorSidebarContentFurniture,
    wall_unit: FamilyEditorSidebarContentFurniture,
    tall_unit: FamilyEditorSidebarContentFurniture,
    storage_unit: FamilyEditorSidebarContentFurniture,
    // base_unit split (Phase 3k + corner refactor — BaseUnitLineMigrator)
    base_unit_standard: FamilyEditorSidebarContentFurniture,
    base_unit_sink: FamilyEditorSidebarContentFurniture,
    base_unit_hob: FamilyEditorSidebarContentFurniture,
    base_unit_dishwasher: FamilyEditorSidebarContentFurniture,
    base_unit_standard_corner: FamilyEditorSidebarContentFurniture,
    base_unit_sink_corner: FamilyEditorSidebarContentFurniture,
    base_unit_hob_corner: FamilyEditorSidebarContentFurniture,
    // wall_unit split (Phase 3h + corner refactor — WallUnitLineMigrator)
    wall_unit_standard: FamilyEditorSidebarContentFurniture,
    wall_unit_hood: FamilyEditorSidebarContentFurniture,
    wall_unit_standard_corner: FamilyEditorSidebarContentFurniture,
    wall_unit_hood_corner: FamilyEditorSidebarContentFurniture,
    // tall_unit split (Phase 3i + corner refactor — TallUnitLineMigrator)
    tall_unit_standard: FamilyEditorSidebarContentFurniture,
    tall_unit_oven: FamilyEditorSidebarContentFurniture,
    tall_unit_fridge: FamilyEditorSidebarContentFurniture,
    tall_unit_dishwasher: FamilyEditorSidebarContentFurniture,
    tall_unit_standard_corner: FamilyEditorSidebarContentFurniture,
    // storage_unit split (corner refactor — StorageUnitLineMigrator)
    storage_unit_corner: FamilyEditorSidebarContentFurniture,
  }

  return registry[familyKey] ?? null
}
